import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const TemperatureStations = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const stations = [
    {
      id: 'ST13',
      name: 'ST13 Giza',
      icon: '🏗️',
      color: '#3b82f6',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)'
    },
    {
      id: 'ST14',
      name: 'ST14 Giza Square',
      icon: '🏛️',
      color: '#1e40af',
      gradient: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)'
    },
    {
      id: 'S15',
      name: 'S15 Alrawda',
      icon: '🌳',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)'
    },
    {
      id: 'ST16',
      name: 'ST16 Almalek Elsaleh',
      icon: '👑',
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%)'
    },
    {
      id: 'ST17',
      name: 'ST17 Cut&Cover',
      icon: '⚙️',
      color: '#ef4444',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)'
    }
  ];

  const handleStationClick = (station) => {
    navigate(`/pours/temperature/${station.id}`, { state: { stationName: station.name } });
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <h1>🌡️ تتبع درجات الحرارة</h1>
        </div>

        <div className="dashboard-main">
          <style>{`
            .stations-container {
              padding: 20px;
              max-width: 1200px;
              margin: 0 auto;
            }

            .page-title {
              text-align: center;
              margin-bottom: 30px;
            }

            .page-title h2 {
              font-size: 28px;
              font-weight: 800;
              color: #1e293b;
              margin: 0 0 10px 0;
            }

            .page-title p {
              font-size: 15px;
              color: #64748b;
              margin: 0;
            }

            .stations-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
              gap: 20px;
              margin-top: 20px;
            }

            .station-card {
              background: white;
              border-radius: 16px;
              padding: 30px;
              text-align: center;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
              border: 3px solid transparent;
              position: relative;
              overflow: hidden;
            }

            .station-card::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 6px;
              background: var(--station-gradient);
              opacity: 0;
              transition: opacity 0.3s;
            }

            .station-card:hover::before {
              opacity: 1;
            }

            .station-card:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
              border-color: var(--station-color);
            }

            .station-icon {
              font-size: 64px;
              margin-bottom: 15px;
              display: block;
              filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
            }

            .station-name {
              font-size: 20px;
              font-weight: 700;
              color: #1e293b;
              margin: 0;
              transition: color 0.3s;
            }

            .station-card:hover .station-name {
              color: var(--station-color);
            }

            .station-badge {
              display: inline-block;
              margin-top: 12px;
              padding: 6px 16px;
              background: #f1f5f9;
              color: #64748b;
              border-radius: 20px;
              font-size: 13px;
              font-weight: 600;
              transition: all 0.3s;
            }

            .station-card:hover .station-badge {
              background: var(--station-gradient);
              color: white;
            }

            /* Mobile Optimization */
            @media (max-width: 768px) {
              .stations-container {
                padding: 15px;
              }

              .page-title h2 {
                font-size: 22px;
              }

              .page-title p {
                font-size: 14px;
              }

              .stations-grid {
                grid-template-columns: 1fr;
                gap: 15px;
              }

              .station-card {
                padding: 25px;
              }

              .station-icon {
                font-size: 52px;
              }

              .station-name {
                font-size: 18px;
              }
            }

            /* Very Small Screens */
            @media (max-width: 400px) {
              .station-card {
                padding: 20px;
              }

              .station-icon {
                font-size: 48px;
              }

              .station-name {
                font-size: 16px;
              }

              .station-badge {
                font-size: 12px;
                padding: 5px 12px;
              }
            }
          `}</style>

          <div className="stations-container">
            <div className="page-title">
              <h2>اختر المحطة</h2>
              <p>اضغط على المحطة لعرض الصبات وإضافة قراءات درجات الحرارة</p>
            </div>

            <div className="stations-grid">
              {stations.map((station) => (
                <div
                  key={station.id}
                  className="station-card"
                  onClick={() => handleStationClick(station)}
                  style={{
                    '--station-color': station.color,
                    '--station-gradient': station.gradient
                  }}
                >
                  <span className="station-icon">{station.icon}</span>
                  <h3 className="station-name">{station.name}</h3>
                  <span className="station-badge">اضغط للدخول</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemperatureStations;